import React from 'react';
import Head from 'next/head';

import Layout from 'utils/hocs/layout';
import { applyContexts } from 'utils/providers';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';
import 'semantic-ui-css/semantic.min.css';
import 'react-calendar/dist/Calendar.css';
import 'utils/styles/_reset.scss';
import '@nosferatu500/react-sortable-tree/style.css';

// swiper docs: https://swiperjs.com/swiper-api#param-a11y
import 'swiper/css';
import 'swiper/css/effect-cards';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

// ensuring there is a `self` in Node's environment
// void !function () {
//   typeof self === 'undefined'
//     && typeof global == 'object'
//     && (global.self = global);
// }();

function AmosSPA ({ Component, pageProps }) {

  return applyContexts(
    <Layout
      suppressHydrationWarning
      suppressHydrationInfo
    >
      <Head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width"
        />

        <link
          rel="shortcut icon"
          href="/favicon.png"
          media="(prefers-color-scheme: dark)"
        />

        <link
          rel="shortcut icon"
          href="/favicon-light.png"
          media="(prefers-color-scheme: light)"
        />

        <title>
          {/*
            // TODO: add a title based on user(org)'s settings
          */}AMOS: Advanced Management Operational System
        </title>
        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{__html: `this.name = "mainAMOSwindow";`}}
        />
      </Head>

      <Component
        {...pageProps}
      />

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Layout>,
    { pageProps }
  );
}

export default AmosSPA;
